// Fetch Saga Composer
import composeFetchSaga from 'fc-fetch-worker/src/sagas/composeFetchSaga'

// WebWorker
import worker from 'fc-wrkr-layers'

export default function initialize (controller) {
  const terminate = function terminate () {
    if (worker) {
      worker.terminate()
    }
  }

  return new Promise((resolve) => {
    terminate()

    resolve({
      terminate,
      handleFetch: composeFetchSaga({
        getWorker: function () {
          return worker.getWorker()
        },
      }),
    })
  })
}
